<app-dashboard-layout></app-dashboard-layout>
<div kendoDialogContainer></div>